import React from "react";

export default ({ errors }) => (
  <div className="mb3 br2 f6 ba b--light-red w-100 dark-red bg-washed-red pa2">
    <div className="fw5 mb1 ml2">You have the following errors:</div>
    <ul className="ma0 pl4">
      {errors.map((err, i) => <li key={i}>{err}</li>)}
    </ul>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/generic/form/service/ErrorBox/index.js